









































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import Conf from '@/config/config'
import API from '@/api/api'
import { getUser } from '@/store/userStore'
import { Message } from 'element-ui'
import draggable from 'vuedraggable'
import FileUpload from '@/utils/fileupload/fileUpload'

@Component({
  components: { draggable },
})
export default class ImageUpload extends Vue {
  @Prop({ type: Array, default: (): Array<any> => [] }) fileList!: Array<any>
  @Prop({ type: Number, default: 3 }) private maxFileSize!: number
  @Prop({ type: String, default: '.jpg,.png,.jpeg,.mp4' }) private accept!: string
  @Emit('changeData')
  private changeData() {
    const coverImg = this.syncFileList.map((e: any, index) => {
      e.index = index
      return e
    }).filter(e=>e.url && e.url != '')
    // 过滤下url为空的数据
    this.syncFileList = coverImg
    return coverImg
  }

  public get syncFileList(){
    return this.fileList
  }
  public set syncFileList(val: Array<any>){
    this.updateFileList(val)
  }
  @Emit('update:fileList')
  private updateFileList(val: Array<any>) {
    return val;
  }

  private fileUpload = new FileUpload()

  private fileUploadUrl = Conf.API_HOST + API.fileUpload
  private headers = { Authorization: '' }
  private dialogVisible = false
  private showLoding = false
  private percentage = 0
  private dialogImageUrl = ''
  private videoType = ['mp4', 'avi', 'flv', 'mkv', '3gp', 'mov', 'asf', 'f4v', 'mpeg', 'mpg', 'wmv', 'rm', 'rmvb', 'ts']
  private dragOptions = {
    animation: 200,
    group: 'description',
    disabled: false,
    ghostClass: 'ghost',
    draggable: '.upload-images-img',
  }

  private dialogImageType(url: string) {
    if (!url) {
      return ''
    }
    const lastIndex = url.lastIndexOf('.')
    const suffix = url.substring(lastIndex + 1)
    const isVideo = this.videoType.findIndex((e) => e == suffix)
    if (isVideo >= 0) {
      return 'video'
    }
    return 'img'
  }

  private datadragEnd(evt: any) {
    this.changeData()
  }

  private created() {
    this.headers.Authorization = getUser().token || ''
  }
  public close() {
    this.dialogVisible = false
    const video = this.$refs.video as any
    if (video) {
      video.pause()
    }
  }

  public handleRemove(file: any) {
    let fileUrl = file.url

    if (!fileUrl &&  file.response) {
      fileUrl = file.response.data.fileUrl
    } else {
      this.changeData()
    }
    let index = -1
    for (let i = 0; i < this.syncFileList.length; i++) {
      const f = this.syncFileList[i]
      if (f === fileUrl || f.url === fileUrl) {
        index = i
      }
    }
    this.syncFileList.splice(index, 1)
    this.changeData()
  }
  public handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url
    this.dialogVisible = true
  }
  public beforeUpload(file: any) {
    if (this.syncFileList.length >= this.maxFileSize) {
      Message.error('最多上传' + this.maxFileSize + '张图片')
      return false
    }
    this.showLoding = true
    this.percentage = 0
  }
  // / 超出限制回调
  public  handleExceed(files: any, fileList: any) {
      this.$message.warning(`最多上传9张图片，您选择了${files.length}张，共${files.length + fileList.length}张`)
    }
  public uploadSuccess(response: any) {
    this.showLoding = false
    // console.log('uploadSuccess')
    if (!response) {
      Message.error('上传失败')
      return
    }
    const { res, url } = response

    if (res.status != 200) {
      // 异常
      Message.error('上传失败')
      return
    }

  }

  private async upload_fileUpload(param: any){
    try{
      this.showLoding = true
      // 先添加到数组（占位），保持初始顺序
    const placeholder = { url: '', name: param.file.name, status: 'uploading' };
    const currentIndex = this.syncFileList.push(placeholder) - 1;
      // console.log("文件上传")
      // console.log(param)
      const result = await this.fileUpload.fileUpload(param.file)
      // console.log(result)
      if(result.res.status == 200){
        // 替换占位元素，保持原始顺序
        this.syncFileList.splice(currentIndex, 1, result);
        // this.syncFileList.push(result)
        this.changeData()
      }
      this.showLoding = false
      return result
    }catch(e){
      console.log("文件上传发生错误")
      console.log(e)
      this.showLoding = false
    }

  }


}
